import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { useMemo, useState, useRef, useEffect } from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, LinearProgress, Paper } from "@mui/material";
import moment from "moment-timezone";
import ChartUnSelected from "../../../asset/image/ChartUnSelected.svg";
import { getTimezoneCity, readableBytesAsGB } from "../../../utils/util";
import Card from "@mui/material/Card";
import { makeStyles } from "@material-ui/core/styles";
import Download from '../../../asset/image/DownloadUsage.svg';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import upArrow from '../../../asset/image/newUpArrow.svg';
import PieChart from "./PieChart";
import NewDownloadButton from '../../../asset/image/NewDownloadButton.svg';
import PlanHierarchy from "./PlanHierarchy";
import { getStarlinkPlanUsageTopWidget } from "../../StarlinkReports/slice";
import _ from "lodash";
import close from "../../../asset/image/cross.svg";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { CsvParameters, downloadAsCSV } from "../../../actions/Users/authenticateCsvDownload";
import DownloadCSV, { clearCsvDownload } from "../../DownloadCSV";

NoDataToDisplay(Highcharts);

const useStyles:any = makeStyles({
    colorPrimary: {
        backgroundColor: '#D6DAFA',
    },
    barColorPrimary: {
        backgroundColor: '#2F4B82',
    }
});

const AssetUsageBarChart = (props) => {
    const { selectedOu, startDate, endDate, assetUsage, assetPlanUsageSplit, userTimezone, expand, toggleExpand, parentPoolId, setParentPoolId, getStarlinkPlanUsageTopWidget, starlinkUsageTopWidget, planFilter, setPlanFilter, subTab, setSelectedRow, setExpandedRows, selectedRow, expandedRows, planData, selectedFilter, defaultFilters, setSelectedFilter, csvDataDownloded, csvDownloadId, filters } = props;

    const dispatch = useDispatch();
    const timeZone = getTimezoneCity(userTimezone);
    const [cardsData, setCardsData] = useState([
        { title: "TOTAL USAGE", value: 0, value2: 0, isGB: true },
        { title: "ORGANIZATION", value: 0, isGB: false },
        { title: "SERVICE LINES", value: 0, isGB: false }
    ]);
    const classes = useStyles();
    const [halfHeight, setHalfHeight] = useState<any>();
    const [zoomCharts, setZoomCharts] = useState<any>({ graph1: false, graph2: false });
    const [selectedTab, setSelectedTab] = useState('plans');
    const [chartData, setChartData] = useState<any>([]);
    const [serviceLinesData, setServiceLinesData] = useState<any>([]);
    const [count, setCount] = useState<any>(0);
    const [slCount, setSLCount] = useState(0);

    useEffect(() => {
        const updateHeight = () => {
            const totalHeight:number = window.innerHeight - (expand.isCardExpanded ? 390 : 320);
            setHalfHeight(totalHeight);
        };
        updateHeight();
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, [expand.isCardExpanded]);

      const formattedData = useMemo(() => {
        const data:any = {
            global_priority: [],
            legacy_plans_data: [],
            local_priority: [],
            mobile_priority_data:[],
            other_data:[]
        };
        
        assetPlanUsageSplit && Object.keys(assetPlanUsageSplit)?.forEach((key) => {
            const series = assetPlanUsageSplit?.[key];
            series?.forEach(({ x, y }) => {
                const timestamp = x;
                const usage_value = y;
                if (key === "global_priority") data.global_priority.push([timestamp, usage_value]);
                if (key === "legacy_plans_data") data.legacy_plans_data.push([timestamp, usage_value]);
                if (key === "local_priority") data.local_priority.push([timestamp, usage_value]);
                if (key === "mobile_priority_data") data.mobile_priority_data.push([timestamp, usage_value]);
                if (key === "other_data") data.other_data.push([timestamp, usage_value]);
            });
        });
    
        return { data, cardsData };
    }, [assetUsage, assetPlanUsageSplit]);


    const HighchartsInstance = { ...Highcharts };
    Exporting(HighchartsInstance);
    ExportData(HighchartsInstance);
    Highcharts.setOptions({
        exporting: { enabled: false },
    });

    const selectedValues: any = [].concat(selectedFilter || []);
    const isTotalUsage = selectedValues.includes('total_usage');

const series = !_.isEmpty(planFilter)
  ? [
      {
        name: "Global Priority GB",
        data: formattedData?.data?.global_priority,
        stack: "gb",
        color: "#3a88d3",
      },
      {
        name: "Legacy Plans GB",
        data: formattedData?.data?.legacy_plans_data,
        stack: "gb",
        color: "#4464f3",
      },
      {
        name: "Local Priority GB",
        data: formattedData?.data?.local_priority,
        stack: "gb",
        color: "#1d3fa6",
      },
      {
        name: "Mobile Priority GB",
        data: formattedData?.data?.mobile_priority_data,
        stack: "gb",
        color: "#8ac9e3",
      },
      {
        name: "Other Data",
        data: formattedData?.data?.other_data,
        stack: "gb",
        color: "#8ac9e3",
      }
    ]
  : [];


   useEffect(() => {
    setCardsData([
        { title: "TOTAL USAGE", value: 0, isGB: true },
        { title: "ORGANIZATION", value: 0, isGB: false },
        { title: "SERVICE LINES", value: 0, isGB: false }
    ]);
    if(!_.isEmpty(planFilter) && selectedOu?.id) {
        getStarlinkPlanUsageTopWidget(parentPoolId, selectedOu?.id, planFilter?.plan_id, planFilter?.type, planFilter?.account_number, selectedFilter, filters)
    }
   }, [selectedOu, parentPoolId, planFilter])

   useEffect(() => {
    if (!_.isEmpty(starlinkUsageTopWidget)) {
        const data = starlinkUsageTopWidget?.[0] || {};
        
        setCardsData([
            { title: "TOTAL USAGE", value: data.total_usage ?? 0, value2: data.total_size ?? 0, isGB: true },
            // { title: "TOTAL PRIORITY USAGE", value: data.total_priority_usage ?? 0, isGB: true },
            { title: "ORGANIZATION", value: data.total_sub_organizations ?? 0, isGB: false },
            { title: "SERVICE LINES", value: data.total_service_lines ?? 0, isGB: false }
        ]);
    }
}, [starlinkUsageTopWidget]);

    const selectedDate = new Date();
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();

    const firstDayOfMonth = Date.UTC(year, month, 1);
    const lastDayOfMonth = Date.UTC(year, month + 1, 0);  
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    
    const tickPositions:any = [];
    let currentDate = firstDayOfMonth;

    while (currentDate <= lastDayOfMonth) {
        let date = new Date(currentDate);
        let day = date.getDate();
        const shouldSkip30 = daysInMonth === 31 && day === 30;

        if (!shouldSkip30 && (day % 5 === 0 || currentDate === firstDayOfMonth || currentDate === lastDayOfMonth)) {
            tickPositions.push(currentDate);
        }

        currentDate += 1000 * 60 * 60 * 24;
    }

    const options = {
        time: {
            // timezone: timeZone,
            useUTC: true
        },
        chart: {
            type: "column",
            height: `${((halfHeight * 55) / 100)}px`,
            zoomType: "x",
            plotBorderWidth: 1,
            style: {
                fontFamily: "Roboto, Nunito Sans, Arial, Verdana, Helvetica, sans-serif",
            },
            marginLeft: 85,
            spacingRight: 10,
        },
        title: {
            text: "",
            align: "left",
            floating: true,
            x: 12,
            y: 32,
            style: {
                fontWeight: "500",
            },
        },
        lang: {
            noData: "No Data",
        },
        noData: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                color: "#303030",
            },
        },
        credits: {
            enabled: false,
        },
        legend: {
            enabled: true,
        },
        plotOptions: {
            column: {
                stacking: "normal",
                cursor: 'pointer',
                dataLabels: {
                    enabled: false,
                },
                pointWidth: 15
            },
        },
        tooltip: {
            shared: true,  
            pointFormat:
                '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} GB</b><br/>',
            valueDecimals: 0,
            borderWidth: 1,
        },
        xAxis: {
            gridLineWidth: 0.5,
            type: "datetime",
            min: firstDayOfMonth,
            max: lastDayOfMonth,
            tickPositions: tickPositions,
            labels: {
                formatter: function (this: any) {
                  let date = new Date(this.value);
                  let day = date.getDate();
                  let month = Highcharts.dateFormat('%b', this.value);
                  return `${month} ${day}`;
                },
                style: {
                  fontSize: "12px"
                }
            }
        },
        yAxis: {
            // tickInterval: 50,
            gridLineWidth: 1,
            labels: {
                format: "{value}",
            },
            title: {
                text: 'Usage (GB)',
                offset: 65,
            },
        },
        exporting: {
            enabled: false,
            csv: {
                columnHeaderFormatter: (item, key) => {
                    if (item.isXAxis) {
                        return 'Time';
                    }
                    return `${item.name.replace(" GB", "")} (GB)`;
                }
            }
        },
        series: series,
    };

    function addCommasToNumber(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    // Calculate total usage for Priority, Standard, and Non-Billable
    const totalUsage = Number(formattedData?.cardsData[0]?.value) +  Number(formattedData?.cardsData[1]?.value) +  Number(formattedData?.cardsData[2]?.value);

    // Calculate progress for each item
    const calculateProgress = (value, total) => (value / total) * 100;

    // Function to format values based on size (GB or TB)
    const formatUsage = (valueInGB) => {
        if (Number(valueInGB) >= 1000) {
            const tbValue = Number(valueInGB) / 1000;
            return `${tbValue.toFixed(2)} TB`;
        } else {
            return `${Number(valueInGB).toFixed(2)} GB`;
        }
    };

    const chartRef = useRef<HighchartsReact.RefObject>(null);

    const handleDownloadCSV = () => {
        if (chartRef.current?.chart) {
            const csvData = chartRef.current.chart.getCSV();
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'starlink_usage_data.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error('Chart reference is null or not initialized.');
        }
    };

    const chartRefPerPlan = useRef<HighchartsReact.RefObject>(null);
    const handleDownloadCSVPerPlan = () => {
        if (!chartRefPerPlan.current?.chart) {
            console.error('Chart reference is null or not initialized.');
            return;
        }

        const chart = chartRefPerPlan.current.chart;
        let csvContent = "";
        let header = "";

        if (selectedTab === 'plans') {
            header = "Plan,Usage (GB)\n";
        } else if (selectedTab === 'service_lines') {
            header = "Service Line,Usage (GB)\n";
        } else {
            header = "Category,Usage (GB)\n";
        }

        const categories = chart.xAxis[0].categories;
        const series = chart.series[0];

        csvContent += header;
        categories.forEach((category, index) => {
            const usage = series.data[index]?.y ?? 0;
            csvContent += `${category},${usage}\n`;
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'chart_usage_data.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const getUsageSource = () => {
        const end_date = moment(endDate, 'YYYY-MM-DD HH:mm:ss');
        const start_date = moment(startDate, 'YYYY-MM-DD HH:mm:ss');

        const hoursDifference = moment.duration(end_date.diff(start_date)).asHours();
        if (hoursDifference <= 24) {
            return 'aggregation_table';
        } else {
            return 'direct_source';
        }
    }

    const handleDownloadReport = () => {
        const start_date = startDate.format('YYYY-MM-DD');
        const end_date = endDate.format('YYYY-MM-DD');
        const source = getUsageSource();

        const selectedValues: any = [].concat(selectedFilter || []);
        const isStandard = selectedValues?.includes('standard');
        const isTotalUsage = selectedValues?.includes('total_usage');
        const hasMonthly = filters.planduration.includes("Monthly");
        const hasYearly = filters.planduration.includes("Yearly");
        const dur = hasMonthly && hasYearly ? "'monthly','yearly'" : hasMonthly ? "'monthly'" : hasYearly ? "'yearly'" : "'monthly','yearly'";
        
        const params: CsvParameters = {
            type: "QUERY_PG",
            id: "starlink-planUsage-charts",
            queryName: selectedTab == 'plans' ? 'GET_STARLINK_USAGE_POOL_PLANS_CHART_V2' : 'GET_STARLINK_USAGE_SERVICE_LINES_CHART_V2',
            payload: {
                parent_pool_id: parentPoolId,
                from_date: start_date,
                to_date: end_date,
                usage_source: source,
                id: planFilter?.plan_id,
                type: planFilter?.type,
                account_number: planFilter?.account_number,
                opt_in_priority: filters.datatype.includes("OptinPriority") ? 1 : 0,
                priority: filters.datatype.includes("Priority") ? 1 : 0,
                standard: filters.datatype.includes("Standard") ? 1 : 0,
                non_billable: filters.datatype.includes("NonBillable") ? 1 : 0,
                duration: dur,
                offset: 0,
                limit: selectedTab == 'plans' ? count : slCount
            }
        }
        dispatch(downloadAsCSV(params))
    }

    const convertToCsv = (data: any[][]) => {
        const [_columns, ...rows] = data;
        const csvRows: any[] = [];
        rows.forEach(row => {
            selectedTab == 'plans' ?   csvRows.push([row[1], row[2]]) : csvRows.push([row[0], row[1]])
        })
        return selectedTab === 'plans'
            ? [['Plan Name', 'Usage (GB)'], ...csvRows]
            : [[ 'Service Line Name', 'Usage (GB)'], ...csvRows];
    }

    useEffect(() => {
        if (csvDataDownloded && csvDataDownloded.length > 0) {
            if (csvDownloadId === 'starlink-planUsage-charts') {
                DownloadCSV(convertToCsv(csvDataDownloded), {
                    formatters: {
                        0: 'ESC-COMMA',
                    }
                });
                return () => {
                    dispatch(clearCsvDownload())
                }
            }
        }
    }, [csvDataDownloded])

    return (
        <>
            {expand.isCardExpanded && (
                <Grid className="cards plan-usage-cards-starlink" container columns={12} spacing={2}>
                    {cardsData.map((card, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                            <Card className="card-widget" id="removeBoxShadow">
                                <Box className="cardHeader cardHeader-serviceLines">
                                    <span className="cardTitle">{card.title}</span>
                                </Box>
                                <Box className="cardContents">
                                    <Box className="cardActive">
                                        <div className="content">
                                            {card.isGB ? `${(card.value ?? 0).toFixed(2)} ${card.value2 ? '' : 'GB'}` : card.value ?? 0}
                                            {card.value2 ? ` / ${card.value2} GB` : ''}
                                        </div>
                                    </Box>
                                </Box>
                                <Box sx={{ margin: '0 10px 5px 10px' }}>
                                    <LinearProgress
                                        sx={{ "--LinearProgress-radius": "10px" }}
                                        classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }}
                                        variant="determinate"
                                        value={100}
                                    />
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
            <div style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', maxHeight: expand.isCardExpanded ? 'calc(100vh - 335px)' : 'calc(-264px + 100vh)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0 6px 0 15px' }}>
                    <span style={{ fontFamily: 'Inter', fontWeight: '600', fontSize: '14px' }}>Graphs</span>
                    <img src={upArrow} alt={expand.isChartsExpanded ? "collapse" : "expand"} onClick={() => toggleExpand('isChartsExpanded')} style={!expand.isChartsExpanded ? { transform: 'rotate(180deg)', cursor: 'pointer' } : { transform: 'rotate(0deg)', cursor: 'pointer' }} />
                </div>
                {expand.isChartsExpanded && <Grid container spacing={1} style={{maxHeight: expand.isCardExpanded ? 'calc(100vh - 345px)' : 'calc(-285px + 100vh)'}}>
                    <Grid item md={5} lg={5}>
                        <PlanHierarchy setParentPoolId={setParentPoolId} parentPoolId={parentPoolId} setPlanFilter={setPlanFilter} subTab={subTab} setSelectedRow={setSelectedRow} setExpandedRows={setExpandedRows} selectedRow={selectedRow} expandedRows={expandedRows} planData={planData} expand={expand} />
                    </Grid>
                    <Grid container item md={7} lg={7} direction="row">
                        <Grid container item md={12} lg={12} className="Starlink-Usage-LineChart">
                            <Grid item md={11} lg={11}>
                                <PieChart parentPoolId={parentPoolId} planFilter={planFilter} halfHeight={halfHeight} selectedFilter={selectedFilter} expand={expand} count={count} setCount={setCount} slCount={slCount} setSLCount={setSLCount}
                                    chartRef={chartRefPerPlan} selectedTab={selectedTab} setSelectedTab={setSelectedTab} chartData={chartData} setChartData={setChartData} serviceLinesData={serviceLinesData} setServiceLinesData={setServiceLinesData} filters={filters}/>
                            </Grid>
                            <Grid item md={1} lg={1} style={{display: 'flex', alignItems: 'flex-start', paddingTop: '10px', justifyContent: 'center'}}>
                                <ZoomInIcon style={{ width: '24px', height: '24px', cursor: 'pointer', color: '#244c84' }} onClick={() => setZoomCharts({graph1: true})} fontSize='small' />
                                {selectedTab == 'plans' && chartData?.length > 0 && <img src={NewDownloadButton} alt="download" onClick={handleDownloadReport} style={{ width: '27px', height: '27px', cursor: 'pointer' }} />}
                                {selectedTab == 'service_lines' && serviceLinesData?.length > 0 && <img src={NewDownloadButton} alt="download" onClick={handleDownloadReport} style={{ width: '27px', height: '27px', cursor: 'pointer' }} />}
                            </Grid>
                        </Grid>
                        <Grid container item md={12} lg={12} className="Starlink-Usage-LineChart">
                            <Grid item md={11} lg={11}>
                                <Paper elevation={1} className="starlink--reports--usage_chart--container plan-starlink--reports--usage_chart--container">
                                    <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
                                </Paper>
                            </Grid>
                            <Grid item md={1} lg={1} style={{display: 'flex', alignItems: 'flex-start', paddingTop: '5px', justifyContent: 'center'}}>
                                <ZoomInIcon style={{ width: '24px', height: '24px', cursor: 'pointer', color: '#244c84' }} onClick={() => setZoomCharts({graph2: true})} fontSize='small' />
                                {series?.some(item => item?.data?.length > 0) && (
                                    <div onClick={handleDownloadCSV}>
                                        <img style={{ width: '27px', height: '27px', cursor: 'pointer', color: '#244c84' }} src={NewDownloadButton} alt="" />
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>}
            </div>
            {zoomCharts?.graph1 ? <ZoompedCharts open={zoomCharts?.graph1} setOpen={setZoomCharts} parentPoolId={parentPoolId} planFilter={planFilter} ref={chartRefPerPlan} selectedFilter={selectedFilter} expand={expand} selectedTab={selectedTab} setSelectedTab={setSelectedTab} handleDownload={handleDownloadReport} chartData={chartData} setChartData={setChartData} serviceLinesData={serviceLinesData} setServiceLinesData={setServiceLinesData} count={count} setCount={setCount} slCount={slCount} setSLCount={setSLCount} filters={filters}/> : null}
            {zoomCharts?.graph2 ? <ZoompedChartsTimeSeries open={zoomCharts?.graph2} setOpen={setZoomCharts} options={options} ref={chartRef} series={series} handleDownloadCSV={handleDownloadCSV} defaultFilters={defaultFilters} setSelectedFilter={setSelectedFilter} selectedFilter={selectedFilter} /> : null}
        </>
    );
};

const ZoompedCharts = ({ open, setOpen, parentPoolId, planFilter, ref, selectedFilter, expand, selectedTab, setSelectedTab, handleDownload, chartData, setChartData, serviceLinesData, setServiceLinesData, count, setCount, slCount, setSLCount, filters }) => {

    return (
        <Dialog className="menuScroll starlink-plan-usage-popup-charts" onClose={() => setOpen({ graph1: false })} open={open}>
            <DialogTitle className="invite-user-padding" style={{ fontWeight: 500, fontSize: "18px", background: "#f5f5f5" }}>
                <Grid item container className="inter-font" style={{ color: "#45464E" }}>
                    Graphs
                    <Grid style={{ marginLeft: "auto" }}>
                        <img src={close} onClick={() => setOpen({ graph1: false })} style={{ width: "24px", height: "24px", cursor: "pointer" }} />
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent style={{ width: '1152px', height: "max-content", paddingBottom: "10px" }}>
                <Grid container md={12} lg={12} direction="row">
                    <Grid item md={12} lg={12} className="Starlink-Usage-LineChart">
                        <PieChart parentPoolId={parentPoolId} planFilter={planFilter} isPopup={true} selectedFilter={selectedFilter} expand={expand} selectedTab={selectedTab} setSelectedTab={setSelectedTab} handleDownload={handleDownload}
                        chartData={chartData} setChartData={setChartData} serviceLinesData={serviceLinesData} setServiceLinesData={setServiceLinesData} count={count} setCount={setCount} slCount={slCount} setSLCount={setSLCount} filters={filters}/>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

const ZoompedChartsTimeSeries = ({ open, setOpen, options, ref, series, handleDownloadCSV, defaultFilters, setSelectedFilter, selectedFilter }) => {

    return (
        <Dialog className="menuScroll starlink-plan-usage-popup-charts" onClose={() => setOpen({ graph2: false })} open={open}>
            <DialogTitle className="invite-user-padding" style={{ fontWeight: 500, fontSize: "18px", background: "#f5f5f5" }}>
                <Grid item container className="inter-font" style={{ color: "#45464E" }}>
                    Graphs
                    <Grid style={{ marginLeft: "auto" }}>
                        <img src={close} onClick={() => setOpen({ graph2: false })} style={{ width: "24px", height: "24px", cursor: "pointer" }} />
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent style={{ width: '1152px', height: "max-content", paddingBottom: "10px" }}>
                <Grid container md={12} lg={12} direction="row">
                    <Grid item md={12} lg={12} className="Starlink-Usage-LineChart">
                        <Grid className="starlink--reports--usage_chart--container plan-starlink--reports--usage_chart--container" mt={1}>
                            <div className="analytics-sub-tabs-container" style={{ height: 'unset', display: 'flex', gap: '8px', paddingLeft: '84px' }}>
                                {/* {defaultFilters.map((filter) => (
                                    <Button
                                        key={filter.label}
                                        // style={{ width: "120px" }}
                                        className="analytics-sub-tabs"
                                        id={selectedFilter?.includes(filter.label) ? "selectedTab-background" : ""}
                                        onClick={() => setSelectedFilter(filter.label)}
                                    >
                                        {filter.name}
                                    </Button>
                                ))} */}
                                {series?.some(item => item?.data?.length > 0) && (
                                    <div className="margin-left-auto" onClick={handleDownloadCSV}>
                                        <img src={NewDownloadButton} alt="" style={{ cursor: "pointer" }} />
                                    </div>
                                )}
                            </div>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={{ ...options, chart: { ...options.chart, height: 350 } }}
                                ref={ref}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

const mapStateToProps = (state) => ({
    assetUsage: state.starlinkReports.assetUsage,
    assetPlanUsageSplit: state.starlinkReports.assetPlanUsageSplit,
    starlinkUsageTopWidget: state.starlinkReports.starlinkUsageTopWidget,
    userTimezone: state.authReducer.userTimezone,
    newSummaryServiceLine: state?.authReducer?.newSummaryServiceLine,
    selectedOu: state.authReducer.selectedOu,
    csvDataDownloded: state.authReducer.csvDataDownloded,
    csvDownloadId: state.authReducer.csvDownloadId,
});

export default withRouter(connect(mapStateToProps, { getStarlinkPlanUsageTopWidget })(AssetUsageBarChart));